import { render, staticRenderFns } from "./comp_dpc-Hotspot.vue?vue&type=template&id=4984c6d3&scoped=true&"
import script from "./comp_dpc-Hotspot.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-Hotspot.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-Hotspot.vue?vue&type=style&index=0&id=4984c6d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984c6d3",
  null
  
)

export default component.exports